import { formatWithHoursMinutes } from 'shared/time-utilites'
import FeatureBlock from '@components/FeatureBlock'

import { selectedCreditCardSelector } from 'booking/selectors'
import { getCreditCardNumberPreview } from 'shared/utils'

import './styles.scss'

const BookingSummary = ({ creditCard, rateName, fromDateTime, toDateTime, location, vehicles, deliveryAddress }) => (
    <div className="booking-summary mb-3">
        <h2 className="booking-summary__title">{rateName}</h2>
        <div className="d-flex mb-3">
            <div className="mr-3">
                <p className="booking-summary__fields-label text-left">
                    <T>dashboard.label.range.s.date</T>
                </p>
                <p className="text-nowrap">{formatWithHoursMinutes(fromDateTime)}</p>
            </div>
            <div className="mr-3">
                <p className="booking-summary__fields-label text-left">
                    <T>dashboard.label.range.e.date</T>
                </p>
                <p className="text-nowrap">{formatWithHoursMinutes(toDateTime)}</p>
            </div>
        </div>

        {location && (
            <FeatureBlock label={location} icon="location-pin" className="booking-summary__icon-labels" size="xs" />
        )}
        {vehicles && (
            <FeatureBlock
                label={vehicles.map(vehicle => vehicle.tag).join(', ')}
                icon="car"
                className="booking-summary__icon-labels"
                size="xs"
            />
        )}

        {creditCard && (
            <FeatureBlock
                label={getCreditCardNumberPreview({
                    cardLast4: creditCard.cardLast4,
                    nickName: creditCard.nickName,
                    expDate: creditCard.expDate,
                })}
                icon="card"
                className="booking-summary__icon-labels"
                size="xs"
            />
        )}

        {deliveryAddress && (
            <FeatureBlock label={deliveryAddress} icon="address" className="booking-summary__icon-labels" size="xs" />
        )}
    </div>
)

BookingSummary.propTypes = {
    creditCard: PropTypes.shape({}),
    rateName: PropTypes.string.isRequired,
    fromDateTime: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
    toDateTime: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
    location: PropTypes.string,
    vehicles: PropTypes.array,
    deliveryAddress: PropTypes.string,
}

const mapStateToProps = createStructuredSelector({
    creditCard: selectedCreditCardSelector,
})

export default connect(mapStateToProps)(BookingSummary)
